import { forwardRef } from 'react';
import TextAreaInternal from './text-area-internal';
const TextArea = forwardRef(TextAreaInternal);
export default TextArea;
